import React from "react";
import { ImgDescTypes } from "../../../types/ContentCard";
import { detectDeviceType } from "../../../utils/detectDeviceType";
import { ImgDescContainer } from "./ImgDescStyles";

const ImgDesc: React.FC<{
  contentCardData: ImgDescTypes;
  tabletLandscape: boolean;
}> = ({ contentCardData, tabletLandscape }) => {
  return (
    <ImgDescContainer
      deviceType={detectDeviceType()}
      isLandscape={tabletLandscape}
      data-sm-content="imgDesc"
    >
      <img
        src={contentCardData.data.pictureUrl}
        alt={contentCardData.data.pictureAlt}
      />
      <h3>{contentCardData.data.descText}</h3>
    </ImgDescContainer>
  );
};

export default ImgDesc;
